import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  confirmButton: {
    width: 120,
    height: 35,
    marginLeft: "5%",
    backgroundColor: "#00A88F",
    cursor: "pointer",
    borderRadius: "23px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

  },
  confirmButtonTypography: {
    color: "#FFFFFF",
    fontSize: 14,
    fontFamily: "Raleway",
    fontWeight: 700,
    fontStyle: "normal",
    letterSpacing: "0.05em",
    lineHeight: "21px",
  },
  buttons: {
    position: "absolute",
    bottom: 18,
    display: "flex",
    marginLeft: "40%",
    flexDirection: "row-reverse",
  },
  closeButton: {
    width: 90,
    height: 35,
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  closeButtonColor: {
    color: "#263057",
    cursor: "pointer",
    fontSize: 16,
    "&:hover": {
      color: "#1BF57F",
    },
    fontWeight: 700,
    fontFamily: "Raleway",
    fontStyle: "normal",
    lineHeight: "23px",
  },
}))

export default useStyles
